/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
  Typography,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AllInboxOutlinedIcon from "@mui/icons-material/AllInboxOutlined";
import { useState, useEffect } from "react";
import { cambiaArea } from "../../services/ProduccionService";
import { getCacheData } from "../../services/CacheService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import DatosAnteojoArreglo from "./DatosAnteojoArreglo";
import DatosBandejaActual from "./DatosBandejaActual";
import DatosAreaActual from "./DatosAreaActual";
import DatosAccordion from "./DatosAccordion";
import WaitingDialog from "../../utils/WaitingDialog";

const initialCambiarAreaData = {
  idAreaDestino: "",
  observaciones: "",
};
//
// ###########################################################################
//
const CambiarAreaAnteojoArregloDialog = ({
  idGestionAtencion,
  anteojoArreglo,
  codigoAnteojoArreglo,
  idGcAnteojoArreglo,
  onCambiarArea,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [cambiarAreaData, setCambiarAreaData] = useState(initialCambiarAreaData);
  const [areas, setAreas] = useState([]);
  const [valueACArea, setvalueACArea] = useState({
    id: "",
    descripcion: "",
  });
  const [inputvalueACArea, setInputvalueACArea] = useState("");
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [datosAccordionSummaryCargados, setDatosAccordionSummaryCargados] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreas();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (accordionExpanded && !datosAccordionSummaryCargados) {
      setDatosAccordionSummaryCargados(true);
    }
  }, [accordionExpanded]);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      let _idAreaActual = localStorage.getItem("id_area_deposito");
      const _response = response.data.data.filter(area => area.id !== _idAreaActual && area.actividad === "produccion" && !area.produccion_despacho);
      setAreas(_response);
    } else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
      return;
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setCambiarAreaData({
      ...cambiarAreaData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const getBandejaActual = (parBandejaActual) => { };
  //
  // ################################################################################
  //
  const cambiarArea = async () => {
    if (!cambiarAreaData.idAreaDestino) {
      // si no se ha indicado el area de destino

      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el área de destino",
      });
      setShowMessage(true);
      return;
    }

    let _cambiarAreaObject = {
      anteojo_arreglo: anteojoArreglo,
      id_gc_anteojo_arreglo: idGcAnteojoArreglo,
      id_area_destino: cambiarAreaData.idAreaDestino,
      observaciones: cambiarAreaData.observaciones,
    };

    save(_cambiarAreaObject);
  };
  //
  // ################################################################################
  //
  const save = async (parCambiaArea) => {
    setIsDoingSomething(true);
    const response = await cambiaArea(parCambiaArea);
    setIsDoingSomething(false);

    if (response.ok) {
      onCambiarArea();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          CAMBIO DE ÁREA {anteojoArreglo.toUpperCase()} {codigoAnteojoArreglo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Accordion
            sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
            expanded={accordionExpanded}
            onChange={() => {
              setAccordionExpanded(!accordionExpanded);
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <DatosAccordion idGestionAtencion={idGestionAtencion} />
            </AccordionSummary>
            <AccordionDetails>
              {datosAccordionSummaryCargados && (
                <>
                  {idGestionAtencion && (
                    <DatosGestionAtencionCliente idGestionAtencion={idGestionAtencion} />
                  )}

                  {anteojoArreglo && (
                    <>
                      <DatosAnteojoArreglo
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                      />

                      <DatosBandejaActual
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                        setBandejaActual={getBandejaActual}
                      />
                    </>
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>

          {anteojoArreglo && (
            <DatosAreaActual
              anteojoArreglo={anteojoArreglo}
              idGcAnteojoArreglo={idGcAnteojoArreglo}
            />
          )}

          <Box
            sx={{
              border: "2px solid steelblue",
              borderRadius: "5px",
              p: 2,
            }}
          >
            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h6" gutterBottom>
                  Enviar a
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Autocomplete
                  id="id-area-destino"
                  size="small"
                  width="50%"
                  value={
                    valueACArea && valueACArea.id ? valueACArea : null
                  }
                  onChange={(event, newValue) => {
                    setvalueACArea(newValue);
                    setCambiarAreaData({
                      ...cambiarAreaData,
                      idAreaDestino: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputvalueACArea}
                  onInputChange={(event, newInputValue) => {
                    setInputvalueACArea(newInputValue);
                  }}
                  options={areas}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Área de Destino" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                // disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={8} lg={8}>
                <TextField
                  id="observaciones"
                  label="Observaciones"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    style: { textAlign: "left" },
                  }}
                  name="observaciones"
                  value={cambiarAreaData.observaciones}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={() => {
                cambiarArea();
              }}
              startIcon={<AllInboxOutlinedIcon />}
              disabled={isDoingSomething}
            >
              Cambiar de Área
            </Button>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={handleCloseDialog}
              disabled={isDoingSomething}
            >
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CambiarAreaAnteojoArregloDialog;
